// extracted by mini-css-extract-plugin
module.exports = {"menu":"_1i-RqnBOcaAQPNY_zxmCR0","menu-hidden":"LZd-S8r1j2rhCyJFKdP4T","menuHidden":"LZd-S8r1j2rhCyJFKdP4T","option":"zDUjVJn_sLezbd0thtl2_","highlighted":"d2m8Ay3Xww8e5vJLXHdin"};